import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
const steps = [{
  num: '1️⃣',
  title: 'COMPRÁS',
  desc: 'Ingresás tu correo y completás el pago.'
}, {
  num: '2️⃣',
  title: 'PAGÁS',
  desc: 'Pagás de forma segura con Mercado Pago, tarjeta o transferencia.'
}, {
  num: '3️⃣',
  title: 'ACCEDÉS',
  desc: 'Recibís el acceso y el material digital para descargar.'
}];
export function HowItWorks() {
  return <section className="py-10 sm:py-20 px-4" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12" data-id="element-148">
          <h2 className="text-3xl sm:text-4xl font-black text-white flex items-center justify-center gap-3 drop-shadow-lg uppercase" data-id="element-149">
            🔽 ¿CÓMO RECIBÍS EL MATERIAL?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12" data-id="element-150">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center flex flex-col items-center bg-green-950/40 p-8 rounded-2xl border border-green-700/20" data-id="element-151">
              <div className="text-5xl mb-4" data-id="element-152">{step.num}</div>
              <h3 className="text-xl font-bold text-white mb-2 uppercase" data-id="element-153">
                {step.title}
              </h3>
              <p className="text-white/80 font-medium" data-id="element-154">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-yellow-400/15 border border-yellow-300/25 p-4 rounded-xl flex items-start gap-3 max-w-lg mx-auto" data-id="element-155">
          <AlertTriangle className="w-6 h-6 text-yellow-300 shrink-0 mt-0.5" data-id="element-156" />
          <div className="text-sm font-medium text-white" data-id="element-157">
            <strong className="uppercase" data-id="element-158">Aclaración:</strong>
            <p data-id="element-159">
              Si no ves el correo en tu bandeja principal a los pocos minutos,
              revisá spam o correo no deseado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}